import {
  SequenceViewer,
  type SequenceViewerTab,
} from "@components/sequence-viewer";
import type { GnomuxFile } from "@db/objects";
import { getObject } from "@db/tree";
import { useTrackRecentView } from "@db/useTrackRecentView";
import { useBlastStore } from "@fetch/blast/store";
import { createFileRoute } from "@tanstack/react-router";
import { useLiveQuery } from "dexie-react-hooks";
import { useCallback, useEffect, useState } from "react";

export const Route = createFileRoute(
  "/_data/view/$fileId_/sequence/$sequenceId",
)({
  component: SequenceMemberComponent,
});

function SequenceMemberComponent() {
  const { fileId, sequenceId } = Route.useParams();
  useTrackRecentView(fileId);
  const [tab, setTab] = useState<SequenceViewerTab>("sequence");
  const [selectedSearchId, setSelectedSearchId] = useState<string | null>(null);

  const setOnSearchReady = useBlastStore((state) => state.setOnSearchReady);

  const handleSearchReady = useCallback((searchId: string) => {
    setSelectedSearchId(searchId);
    setTab("searches");
  }, []);

  useEffect(() => {
    setOnSearchReady(handleSearchReady);
    return () => setOnSearchReady(null);
  }, [setOnSearchReady, handleSearchReady]);

  const file = useLiveQuery(
    () => getObject(fileId) as Promise<GnomuxFile | undefined>,
    [fileId],
  );

  return (
    <SequenceViewer
      sequenceId={sequenceId}
      tab={tab}
      onTabChange={setTab}
      collectionId={fileId}
      collectionName={file?.name}
      isCollectionLocked={file?.isLocked ?? false}
      selectedSearchId={selectedSearchId}
      onSelectSearch={setSelectedSearchId}
      onDeselectSearch={() => setSelectedSearchId(null)}
    />
  );
}
